import React from 'react';
import ReactDOM from 'react-dom';
import { I18nextProvider } from "react-i18next";
import i18next from "i18next";
import Main from './routers';
import { Provider } from 'react-redux';
import { configureAppStore } from '@store/configureStore';
// import { MonitoringServiceClient } from './monitoringpb/monitoring_grpc_web_pb';

const store = configureAppStore();
// const client = new MonitoringServiceClient('http://localhost:8000');

ReactDOM.render(
  <Provider store={store}>
    <I18nextProvider i18n={i18next}>
      <Main />,
    </I18nextProvider>
  </Provider>,
  document.getElementById('root')
);
